export const environment = {
  production: false,
  hmr: false,
  baseApiUrl: "https://api.real876.com/",
  apiUrl: 'https://api.real876.com/',
  key_as: 'NDIwQDQyMUA0MjJANDIzQDQyNEA0MjVANDI2QDQyN0A0MjhANDI5QDQzMEA0MzFANDMyQDQzM0A0MzRANDM1QDQzNkA0MzdANDM4QDQzOUA0NDBANDQxQDQ0MkA0NDNANDQ0QDQ0NUA0NDZANDQ3QDQ0OEA0NDlANDUwQDQ1MQ',
  key_vec: 'NDFANDJANDNANDRANDVANDZANDdANDhANDlANTBANTFANTJANTNANTRANTVANTY'
};

